import { Component, Input } from '@angular/core';

@Component({
  selector: 'solution-finder-card',
  templateUrl: './solution-finder-card.component.html',
  standalone: false,
})
export class SolutionFinderCardComponent {
  @Input() solutionFinderResponse;
}
